
export default class Theme {
  constructor (options = {
    gridColor: 0xffffff,
    // boundingBoxColor: 0x00939D
    boundingBoxColor: 0x35383b
  }) {
    this.gridColor = options.gridColor;
    this.boundingBoxColor = options.boundingBoxColor;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/Theme.js